export const tableHeader = ['Test Name', 'Student Name', 'Status', 'Action']
